import styles from './index.module.scss'
import { DEFAULT_PROFILE_IMAGE_PATH } from 'common/ProviderPreview/constants'

type QuotePanelMobileProps = {
  providerDetails: Provider
}

const QuotePanelMobile: React.FC<QuotePanelMobileProps> = ({
  providerDetails,
}) => {
  const { about, profileImagePath, firstName, lastName } = providerDetails
  const { summary } = about

  const providerImgSrc = profileImagePath
    ? profileImagePath
    : DEFAULT_PROFILE_IMAGE_PATH

  if (!summary) {
    return null
  }

  return (
    <div className={styles.QuotePanelMobile}>
      <div className={styles.QuotePanelMobile_florals}>
        <img
          src="/images/provider-about-florals-mobile.svg"
          alt="Provider background floral illustration"
          width={422}
          height={170}
        />
        <div className={styles.QuotePanelMobile_florals_headshot}>
          <img
            src={providerImgSrc}
            alt={`${firstName} ${lastName}'s profile` + ' image'}
            className={styles.QuotePanelMobile_florals_headshot_img}
          />
        </div>
      </div>

      <div className={styles.QuotePanelMobile_quote}>
        <p>&quot;{summary}&quot;</p>
      </div>
    </div>
  )
}

export default QuotePanelMobile
